import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueResource from 'vue-resource'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'



import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import VCharts from 'v-charts'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
//import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './style/index.scss'
import './permission'

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import VueHtml2pdf from 'vue-html2pdf'


//import { MessageBox } from 'element-ui'

//Vue.prototype.$confirm = MessageBox.confirm
Vue.use(VXETable)
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VCharts)
Vue.component('vue-draggable-resizable', VueDraggableResizable)

Vue.use(VueResource)
Vue.use(ElementUI)
//VXETable.use(VXETablePluginExportXLSX)
Vue.use(Antd)

Vue.use(VueHtml2pdf)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
